/**
 * @param {string} pathname
 * @param {{ principal?: number, rate?: number, tenure?: number, unit?: 'years' | 'months' }} state
 */
export function buildEmiCalculatorSharePath(pathname, state) {
  const params = new URLSearchParams();
  if (state.principal && state.principal > 0) params.set("p", String(Math.round(state.principal)));
  if (Number.isFinite(state.rate)) params.set("r", String(state.rate));
  if (state.tenure && state.tenure > 0) params.set("t", String(state.tenure));
  if (state.unit) params.set("u", state.unit === "months" ? "m" : "y");
  const qs = params.toString();
  return qs ? `${pathname}?${qs}` : pathname;
}

/**
 * @param {string} origin
 * @param {string} pathname
 * @param {Parameters<typeof buildEmiCalculatorSharePath>[1]} state
 */
export function buildEmiCalculatorShareUrl(origin, pathname, state) {
  return `${origin}${buildEmiCalculatorSharePath(pathname, state)}`;
}

/**
 * @param {URLSearchParams | string} input
 */
export function parseEmiCalculatorShareParams(input) {
  const params = typeof input === "string" ? new URLSearchParams(input) : input;
  const pRaw = params.get("p");
  const rRaw = params.get("r");
  const tRaw = params.get("t");
  const uRaw = params.get("u");

  const principal = pRaw && Number(pRaw) > 0 ? Number(pRaw) : null;
  const rate = rRaw !== null && rRaw !== "" && Number.isFinite(Number(rRaw)) ? Number(rRaw) : null;
  const tenure = tRaw && Number(tRaw) > 0 ? Number(tRaw) : null;
  const unit = uRaw === "m" ? "months" : "years";

  return { principal, rate, tenure, unit };
}
